import { type JSX, type ParentProps } from "solid-js";
import clsx from "~/util/html/style";
import { PoweredByTwelve } from "./powered_by_twelve";

// Semantic widths for the card, decoupled from the underlying Tailwind scale.
const WIDTHS = {
  md: "max-w-lg",
  lg: "max-w-2xl",
} as const;

// Centered, branded shell for public-facing forms: a rounded white card with the "Powered by Twelve"
// footer beneath it. Children are the card contents (header + body); each form owns those.
// `toolbar` sits above the card (the patient pages' language picker).
export function PublicFormShell(
  props: ParentProps<{
    width: keyof typeof WIDTHS;
    poweredByLabel?: string;
    toolbar?: JSX.Element;
  }>,
) {
  return (
    <div class="flex min-h-dvh flex-col items-center px-4 py-6 sm:justify-center sm:py-12">
      <div class={clsx("w-full", WIDTHS[props.width])}>
        {props.toolbar}
        <div class="overflow-hidden rounded-2xl bg-white shadow-lg ring-1 shadow-black/5 ring-black/5">
          {props.children}
        </div>
        <PoweredByTwelve label={props.poweredByLabel} />
      </div>
    </div>
  );
}
